module.exports = __webpack_public_path__ + "img/icon-step-finish.6c00e152.png";